import { commonFilter } from './filter';

export default {
  pageName: 'feedsSecurity',
  pageId: '20029',
  pagePath: '/opinion/security',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    C_keyword: {
      buttonId: '200290',
    },
    GPT_Get_Btn: {
      buttonId: '2002901',
    },
    GPT_Confirm: {
      buttonId: '2002902',
    },
    ...commonFilter,
  },
};
